import { ERP } from '../_base/endpoint';
import axios from 'axios';

import global from '../../common/utility/global';

class documentoService {

    /******* QUERIES ******/

    async paginacion(filter) {
        const response = await axios
            .get(`${ERP}administracion/documento/paginacion?${global.formatParameter(filter)}`)
            .then(response => { 
                return response.data; 
            })
            .catch(error => {
                console.log(error);
            });
        return response;
    };

    async listarPorIdTipoComprobante(idTipoComprobante) {
        const response = await axios
            .get(`${ERP}administracion/documento/por-tipo-comprobante/${idTipoComprobante}`)
            .then(response => { 
                return response.data; 
            })
            .catch(error => {
                console.log(error);
            });
        return response;
    };
       /******* TRANSACCIONES ******/

    async registrar(data) {
        const response = await axios
            .post(`${ERP}administracion/documento`, data)
            .then(response => {
                return response;
            })
            .catch(error => {
                console.log(error);
                return error.response ? error.response : {};
            });
        return response;
    };
   
}

export default new documentoService();